function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.875 2.5C1.875 2.15482 2.15482 1.875 2.5 1.875H9.99654C10.3417 1.875 10.6215 2.15482 10.6215 2.5C10.6215 2.84518 10.3417 3.125 9.99654 3.125H3.125V16.875H10C10.3452 16.875 10.625 17.1548 10.625 17.5C10.625 17.8452 10.3452 18.125 10 18.125H2.5C2.15482 18.125 1.875 17.8452 1.875 17.5V2.5Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3081 5.80806C13.5521 5.56398 13.9479 5.56398 14.1919 5.80806L17.9419 9.55806C18.186 9.80214 18.186 10.1979 17.9419 10.4419L14.1919 14.1919C13.9479 14.436 13.5521 14.436 13.3081 14.1919C13.064 13.9479 13.064 13.5521 13.3081 13.3081L16.6161 10L13.3081 6.69194C13.064 6.44786 13.064 6.05214 13.3081 5.80806Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.04175 9.99652C6.04175 9.65134 6.32157 9.37152 6.66675 9.37152H17.5001C17.8453 9.37152 18.1251 9.65134 18.1251 9.99652C18.1251 10.3417 17.8453 10.6215 17.5001 10.6215H6.66675C6.32157 10.6215 6.04175 10.3417 6.04175 9.99652Z"
});

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.6b339592.svg";
export { ForwardRef as ReactComponent };